"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventFieldLabel = eventFieldLabel;
exports.eventMoneyText = eventMoneyText;
const money_1 = require("./money");
// The event log's before → after table and its export, in words (review W13, 2026-11-02): a recorded field reads by a
// name a person uses ("Top of budget", not "Budget max minor"), and an amount in minor units reads as money ("৳57,777",
// not "5777700"). The data itself stays as written (append-only); only how it is read changes.
/** Recorded names that read better as a person's words. Anything else is the name split into words. */
const FIELD_LABELS = {
    budgetMinMinor: 'Bottom of budget',
    budgetMaxMinor: 'Top of budget',
    budgetAmountMinor: 'Budget',
    budgetCurrency: 'Budget currency',
    salaryBandMinMinor: 'Bottom of salary band',
    salaryBandMaxMinor: 'Top of salary band',
    salaryCurrency: 'Salary currency',
    bandMinMinor: 'Bottom of band',
    bandMaxMinor: 'Top of band',
    expectedSalaryMinor: 'Expected salary',
    expectedSalaryCurrency: 'Expected salary currency',
    currentSalaryMinor: 'Current salary',
    currentSalaryCurrency: 'Current salary currency',
    baseSalaryMinor: 'Base salary',
    grossMonthlyMinor: 'Gross a month',
    totalAnnualMinor: 'Total a year',
};
/** "rejectionReasonCode" → "Rejection reason code"; a money field drops its "minor" ("bonusMinor" → "Bonus"). */
function eventFieldLabel(key) {
    const known = FIELD_LABELS[key];
    if (known)
        return known;
    const words = key
        .replace(/Minor$/, '')
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/[_-]+/g, ' ')
        .trim()
        .toLowerCase();
    return words === '' ? key : words.charAt(0).toUpperCase() + words.slice(1);
}
const MINOR_KEY = /^(.*?)(?:Min|Max|Amount)?Minor$/;
const DIGITS = /^\d{1,15}$/;
/** Where a record keeps an amount's currency, after `<name>Currency`: the names the services write it under. */
const CURRENCY_KEYS = ['currency', 'salaryCurrency', 'budgetCurrency'];
function currencyFor(key, record, prefix) {
    for (const name of [`${prefix}Currency`, `${key.replace(/Minor$/, '')}Currency`, ...CURRENCY_KEYS]) {
        const value = record[name];
        if (typeof value === 'string' && (0, money_1.isCurrencyCode)(value))
            return value;
    }
    return null;
}
/**
 * An amount recorded in minor units, as money with its symbol, read with the currency the same record holds. Null when
 * the field isn't an amount, or the value is hidden (`—`) or missing, so the caller shows it as it shows any value.
 * With no currency in the record (an older event), the digits are kept and said to be minor units, never guessed into
 * a currency.
 */
function eventMoneyText(key, value, record) {
    const match = MINOR_KEY.exec(key);
    if (!match)
        return null;
    const digits = typeof value === 'number' && Number.isSafeInteger(value) && value >= 0 ? String(value) : value;
    if (typeof digits !== 'string' || !DIGITS.test(digits))
        return null;
    const currency = currencyFor(key, record, match[1] ?? '');
    if (!currency)
        return `${digits} (minor units)`;
    return (0, money_1.formatMoney)({ amountMinor: BigInt(digits), currency });
}
//# sourceMappingURL=event-field-words.js.map